import { render, staticRenderFns } from "./DraftEditor.vue?vue&type=template&id=97016cb4&scoped=true"
import script from "./DraftEditor.vue?vue&type=script&lang=js"
export * from "./DraftEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97016cb4",
  null
  
)

export default component.exports